import React, { Component } from 'react';
import RadioBtnUnchecked from '../assets/icons/radio_button_unchecked.svg';
import RadiotbnChecked from '../assets/icons/radio_button_checked.svg';
import CheckBoxChecked from '../assets/icons/check_box_checked.svg';
import CheckBoxUnChecked from '../assets/icons/check_box_unchecked.svg';
import CheckSameTimeBox from '../assets/icons/check_same_time.svg';
import { TimePicker } from '../CommonComponents/TimePicker';
import { api } from '../utils';
type Props = {
  selectedBotid: string;
  onSave: Function;
  agentAvailabilityList: any;
  availabilityType: string;
};
type State = {
  defaultCheckRadioBtn: boolean;
  customCheckedBtn: boolean;
  weekDays: {
    name: string;
    id: number;
    check: boolean;
    startTime: string;
    endTime: string;
  }[];
  checkSameTime: boolean;
  sameStartTime: string;
  sameEndTime: string;
};

export default class AgentAvailability extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.fetchDaysChecked = this.fetchDaysChecked.bind(this);
    this.saveAgentAvailability = this.saveAgentAvailability.bind(this);
  }
  setInitialState(): State {
    return {
      defaultCheckRadioBtn: true,
      customCheckedBtn: false,
      weekDays: [
        { name: 'Mon', id: 0, check: false, startTime: '09:00 AM', endTime: '05:30 PM' },
        { name: 'Tue', id: 1, check: false, startTime: '09:00 AM', endTime: '05:30 PM' },
        { name: 'Wed', id: 2, check: false, startTime: '09:00 AM', endTime: '05:30 PM' },
        { name: 'Thu', id: 3, check: false, startTime: '09:00 AM', endTime: '05:30 PM' },
        { name: 'Fri', id: 4, check: false, startTime: '09:00 AM', endTime: '05:30 PM' },
        { name: 'Sat', id: 5, check: false, startTime: '09:00 AM', endTime: '05:30 PM' },
        { name: 'Sun', id: 6, check: false, startTime: '09:00 AM', endTime: '05:30 PM' },
      ],
      checkSameTime: false,
      sameStartTime: '09:00 AM',
      sameEndTime: '05:30 PM',
    };
  }
  componentDidMount() {
    if (this.props.agentAvailabilityList) {
      this.props.agentAvailabilityList.map((data: any, i: number) => {
        this.setState((prevState) => ({
          weekDays: prevState.weekDays.map((obj) =>
            obj.name === data.day
              ? Object.assign(obj, {
                  check: !obj.check,
                  startTime: data.time.split('-')[0],
                  endTime: data.time.split('-')[1],
                })
              : obj
          ),
        }));
      });
    }
    if (this.props.availabilityType) {
      if (this.props.availabilityType === 'custom') {
        this.setState({
          customCheckedBtn: true,
          defaultCheckRadioBtn: false,
        });
      } else {
        this.setState({
          defaultCheckRadioBtn: true,
          customCheckedBtn: false,
        });
      }
    }
  }
  fetchDaysChecked() {
    let days: any = [];
    let sameStartTime: any = [];
    let sameEndTime: any = [];
    if (this.state.checkSameTime) {
      this.state.weekDays.map((data, index) => {
        if (data.check === true) {
          days.push(data.name);
          sameStartTime.push(this.state.sameStartTime);
          sameEndTime.push(this.state.sameEndTime);
        }
      });
    } else {
      this.state.weekDays.map((data, index) => {
        if (data.check === true) {
          days.push(data.name);
          sameStartTime.push(data.startTime);
          sameEndTime.push(data.endTime);
        }
      });
    }
    return {
      checkedDays:
        days.length !== 0 ? days : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      startTime:
        sameStartTime.length !== 0
          ? sameStartTime
          : this.state.sameStartTime
          ? new Array(7).fill(this.state.sameStartTime)
          : [],
      endTime:
        sameEndTime.length !== 0
          ? sameEndTime
          : this.state.sameEndTime
          ? new Array(7).fill(this.state.sameEndTime)
          : [],
    };
  }
  saveAgentAvailability() {
    let type;
    let val;
    if (this.state.defaultCheckRadioBtn) {
      type = 'default';
      val = '';
    } else {
      type = 'custom';
      val = this.fetchDaysChecked();
    }
    let data = {
      type: type,
      botId: this.props.selectedBotid,
      data: val,
    };
    api(`setAgentAvailability`, 'POST', data).then((response) => {
      if (response) {
        this.props.onSave('Agent Availability Updated');
      }
    });
  }
  render() {
    return (
      <div className='agent-availablity-wrapper'>
        <div className='main-wrapper default-wrapper'>
          <img
            src={this.state.defaultCheckRadioBtn ? RadiotbnChecked : RadioBtnUnchecked}
            alt='radio-btn'
            onClick={() => {
              this.setState({
                defaultCheckRadioBtn: true,
                customCheckedBtn: false,
              });
            }}
            style={{ paddingLeft: '5px' }}
          />
          <div className='availability-timmings'>24/7</div>
        </div>
        <div className='custom-wrapper main-wrapper'>
          <div className='custom-sub-wrapper'>
            <img
              src={this.state.customCheckedBtn ? RadiotbnChecked : RadioBtnUnchecked}
              alt='radio-btn'
              onClick={() => {
                this.setState({
                  customCheckedBtn: true,
                  defaultCheckRadioBtn: false,
                });
              }}
              style={{ paddingLeft: '5px' }}
            />
            <div className='availability-timmings'>Custom</div>
          </div>
          <div
            className={`custom-sub-sec-wrapper ${
              this.state.customCheckedBtn === false ? 'disable-data' : ''
            }`}>
            <div style={{ lineHeight: '2.99', position: 'relative' }}>
              {this.state.weekDays.map((data, index) => {
                return (
                  <div className='week-days'>
                    <div style={{ display: 'flex' }}>
                      <img
                        src={data.check ? CheckBoxChecked : CheckBoxUnChecked}
                        alt='checkbox'
                        onClick={() => {
                          this.setState((prevState) => ({
                            weekDays: prevState.weekDays.map((obj) =>
                              obj.id === index
                                ? Object.assign(obj, { check: !data.check })
                                : obj
                            ),
                          }));
                        }}
                      />
                      <div style={{ marginLeft: '7px' }}>{data.name}</div>
                    </div>
                    {this.state.checkSameTime === false && data.check && (
                      <div
                        style={{ display: 'flex', alignItems: 'center' }}
                        className='test'>
                        <TimePicker
                          is24HoursFormat={false}
                          onChange={(selectedTime: string) => {
                            this.setState((prevState) => ({
                              weekDays: prevState.weekDays.map((obj) =>
                                obj.id === index
                                  ? Object.assign(obj, { startTime: selectedTime })
                                  : obj
                              ),
                              sameStartTime: selectedTime,
                            }));
                          }}
                          selectedTime={
                            this.props.agentAvailabilityList.find(
                              (e: any) => e.day === data.name
                            )
                              ? this.props.agentAvailabilityList
                                  .find((e: any) => e.day === data.name)
                                  .time.split('-')[0]
                              : '09:00 AM'
                          }
                        />
                        <span>&nbsp;-&nbsp;</span>
                        <TimePicker
                          is24HoursFormat={false}
                          onChange={(selectedTime: string) => {
                            this.setState((prevState) => ({
                              weekDays: prevState.weekDays.map((obj) =>
                                obj.id === index
                                  ? Object.assign(obj, { endTime: selectedTime })
                                  : obj
                              ),
                              sameEndTime: selectedTime,
                            }));
                          }}
                          selectedTime={
                            this.props.agentAvailabilityList.find(
                              (e: any) => e.day === data.name
                            )
                              ? this.props.agentAvailabilityList
                                  .find((e: any) => e.day === data.name)
                                  .time.split('-')[1]
                              : '05:30 PM'
                          }
                        />
                      </div>
                    )}
                  </div>
                );
              })}
              <div
                style={
                  this.state.checkSameTime
                    ? { position: 'absolute', right: '0', top: '0' }
                    : {}
                }>
                {this.state.checkSameTime && (
                  <div className='selected-time-wrapper'>
                    <TimePicker
                      is24HoursFormat={false}
                      onChange={(selectedTime: string) => {
                        this.setState({
                          sameStartTime: selectedTime,
                        });
                      }}
                      selectedTime={this.state.sameStartTime}
                    />
                    <span>&nbsp;-&nbsp;</span>
                    <TimePicker
                      is24HoursFormat={false}
                      onChange={(selectedTime: string) => {
                        this.setState({
                          sameEndTime: selectedTime,
                        });
                      }}
                      selectedTime={this.state.sameEndTime}
                    />
                  </div>
                )}
                <div
                  className='same-timmings-wrapper'
                  style={this.state.checkSameTime ? { marginTop: '-14px' } : {}}>
                  <img
                    src={this.state.checkSameTime ? CheckSameTimeBox : CheckBoxUnChecked}
                    alt='check box'
                    onClick={() => {
                      this.setState({
                        checkSameTime: !this.state.checkSameTime,
                      });
                      this.fetchDaysChecked();
                    }}
                    style={{ width: '20px' }}
                  />
                  <div className='same-timmings'>Same timings on all days</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='save-wrapper save-agent-wrapper'>
          <div className='save-timezone-details' onClick={this.saveAgentAvailability}>
            Done
          </div>
        </div>
      </div>
    );
  }
}
